import axios from 'axios';
import { useState } from 'react';
import { FormInput } from '../components/FormInput';
import { serverLink } from '../constants/serverlinks';
import history from '../history';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const sendVerificationEmail = () => {
    if (!email) {
      return;
    }
    axios
      .post(`${serverLink}/api/auth/forgot-password/`, {
        email: email,
      })
      .then((res) => {
        if (res.data.message) {
          setMessage(res.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className='flex flex-col h-screen w-screen justify-center items-center p-10'>
      {message ? (
        <div className='text-left space-y-5'>
          <h3 className='p-0'>{message}</h3>
          <p className='p-0'>
            Back to DMS Sims{' '}
            <a
              href='/'
              className='mt-5 text-lightBlue-500 font-bold hover:cursor-pointer hover:underline'
            >
              home page
            </a>
          </p>
        </div>
      ) : (
        <div className='text-left space-y-5'>
          {' '}
          <h3 className='p-0'>Reset password</h3>
          <p className='p-0'>
            To reset your password, enter the email address associated with your
            account below. We’ll send you an email containing a password reset
            link.{' '}
          </p>
          <form>
            <FormInput
              labelText='Email address'
              type='email'
              placeHolderText='me@email.com'
              value={email}
              name='email'
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </form>
          <button
            onClick={() => sendVerificationEmail()}
            className='w-40 mr-4 my-4 py-2 px-4 hover border-2 hover:text-dms-primary hover:border-2 hover:border-dms-primary hover:bg-white text-lg font-medium cursor-pointer transition duration-100 rounded-md z-10 bg-dms-primary text-white'
          >
            Submit
          </button>
          <button
            onClick={() => history.push('/')}
            className='w-40 my-4 py-2 px-4 hover border-2 hover:text-dms-primary hover:border-2 hover:border-dms-primary hover:bg-white text-lg font-medium cursor-pointer transition duration-100 rounded-md z-10 bg-dms-primary text-white'
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};

export default ForgotPassword;
